// import React from "react";
// import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes";
import { UserProvider } from "./context/UserContext";


function App() {
  return (
      <UserProvider>
          <AppRoutes />
      </UserProvider>
  );
}

export default App;
